const scrollerIds = {
  CONTAINER: 'container'
};

export {
  scrollerIds
};
